import React from 'react';
import { ListTaskExecutionsResponse } from '@amzn/snow-nxt-workflow-service-typescript-client';
import ErrorLoader from 'src/components/commonComponents/errorLoader/errorLoader';
import WorkflowExecutionTable from 'src/components/findEntity/workflowExecutionTable';
import { useFetchForSDS } from 'src/hooks/useFetchForSDS';
import { useWorkflowExecutePermission } from 'src/hooks/useWorkflowExecutePermission';
import { useAuthContext } from 'src/providers/AuthContext';
import { SNOW_NXT_WORKFLOW_ENDPOINT } from 'src/config';

export default function SubWorkflowExecutionView({
	childWorkflowId,
	childWorkflowExecutionId,
}: {
	childWorkflowId?: string;
	childWorkflowExecutionId?: string;
}) {
	const { userName } = useAuthContext();
	const { hasExecutePermission } = useWorkflowExecutePermission(childWorkflowId, userName);

	const { isLoading, data, error, fetchData } =
		useFetchForSDS<ListTaskExecutionsResponse>({
			path:
				childWorkflowId && childWorkflowExecutionId
					? `/workflows/${childWorkflowId}/executions/${childWorkflowExecutionId}/tasks`
					: '',
			method: 'GET',
			url: SNOW_NXT_WORKFLOW_ENDPOINT,
		});

	return (
		<>
			<ErrorLoader isLoading={isLoading} error={error} />
			{data && (
				<WorkflowExecutionTable
					workflowId={childWorkflowId ?? ''}
					workflowExecutionId={childWorkflowExecutionId ?? ''}
					taskExecutionData={data.taskExecutions ?? []}
					entityName=""
					hasExecutePermissions={hasExecutePermission}
					refreshView={fetchData}
					tableTitle="Sub-workflow Execution Tasks"
				/>
			)}
		</>
	);
}
